// extracted by mini-css-extract-plugin
module.exports = {"container":"EmojiPicker_container__18Qw7","picker":"EmojiPicker_picker__3qFYe"};